module.exports = __webpack_public_path__ + "ffb856e794840ec8dbb2c7eec56df04f.pdf";